import { render, staticRenderFns } from "./TiptapMod.vue?vue&type=template&id=cf346e3c&scoped=true"
import script from "./TiptapMod.vue?vue&type=script&lang=js"
export * from "./TiptapMod.vue?vue&type=script&lang=js"
import style0 from "./TiptapMod.vue?vue&type=style&index=0&id=cf346e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf346e3c",
  null
  
)

export default component.exports